import { create } from 'zustand';
import { combine } from 'zustand/middleware';

export const useProgressStore = create(
  combine({ isAnimating: false }, (set) => ({
    setIsAnimating: (payload: boolean) => set(() => ({ isAnimating: payload })),
  })),
);
